import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './allRoutes'
import AuthGuard from './auth-guard'

Vue.use(VueRouter)
const AppRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

AppRouter.beforeEach(AuthGuard)

export default AppRouter
